/*
    Стили
*/

import {throttle} from "./ThrottleDebounce";

function setTitlesHeight () {
    if (App.W.outerWidth() > 768) {
        $('.js-similar-titles').each(function (index, el) {
            let titlesHeights = [];
            let $currTitles = $(el).find('.graph-title');

            $currTitles.each(function (index, element) {
                titlesHeights.push($(element).outerHeight());
            });

            // есол ширина меньше 1366, то колонки 2 и одинаковую высоту делаем только у заголовков в первых 2-х столбцах, иначе у всех 3-х
            let maxHeight = App.W.outerWidth() <= 1366 ? Math.max.apply(Math, [$currTitles.eq(0).outerHeight(), $currTitles.eq(1).outerHeight()]) : Math.max.apply(Math, titlesHeights);

            $currTitles.css({
                'min-height': `${maxHeight}px`
            });
        });
    } else {
        $('.graph-title').css({
            'min-height': `0px`
        });
    }
}

App.W.on('load', function () {
    setTitlesHeight();
});

App.W.on('resize', throttle(setTitlesHeight, 500));


// WEBPACK FOOTER //
// ./_src/js/modules/PageStyles.js